export const INITIAL_MODULE_AUTHORIZATIONS_OFFSET = 0;
export const INITIAL_MODULE_AUTHORIZATIONS_LIMIT = 50;
